import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class CategoryDetailService {
    static $inject = ['BaseApiFactory'];
    
    constructor(private baseApiFactory: BaseApiFactory) {}
    InsertCategoryDetail(parentId: number, values) {
        console.log(values);
        return this.baseApiFactory.post<boolean>(`/api/CategoryDetail/CreateNew/${parentId}`, values);
    }
}
lazyRegister.service('CategoryDetailService', CategoryDetailService);
